(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/client/internal/campaign-list-data-fetcher.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/client/internal/campaign-list-data-fetcher.js');

'use strict';

function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const {
  logger
} = svs.numbergames.campaign._internal;
const {
  processCampaignListResponse
} = svs.numbergames.campaign.shared;
const {
  productMapping
} = svs.numbergames;
var _activeFetches = new WeakMap();
var _CampaignListDataFetcher_brand = new WeakSet();
class CampaignListDataFetcher {
  constructor() {
    var _svs$numbergames$camp, _svs$numbergames$camp2;
    _classPrivateMethodInitSpec(this, _CampaignListDataFetcher_brand);
    _classPrivateFieldInitSpec(this, _activeFetches, []);
    this.cache = (_svs$numbergames$camp = (_svs$numbergames$camp2 = svs.numbergames.campaign_cache) === null || _svs$numbergames$camp2 === void 0 ? void 0 : _svs$numbergames$camp2.data) !== null && _svs$numbergames$camp !== void 0 ? _svs$numbergames$camp : {};
  }
  async fetchData() {
    let {
      year,
      month,
      product
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (product && year && month) {
      return await _assertClassBrand(_CampaignListDataFetcher_brand, this, _getApiData).call(this, {
        year,
        month,
        product
      });
    }
    return [];
  }
}
async function _waitForCache(cacheKey) {
  return new Promise(resolve => {
    let retries = 10;
    const RETRY_TIMEOUT = 20;
    const check = () => {
      if (retries && !this.cache[cacheKey]) {
        logger.debug("cacheKey ".concat(cacheKey, " not found. Tries left: ").concat(retries, "."));
        retries--;
        setTimeout(check, RETRY_TIMEOUT);
        return;
      }
      resolve();
    };
    check();
  });
}
async function _getApiData(_ref) {
  let {
    year,
    month,
    product
  } = _ref;
  const cacheKey = "".concat(productMapping.getProductId(product), "_").concat(year, "_").concat(month);
  if (_classPrivateFieldGet(_activeFetches, this).includes(cacheKey)) await _assertClassBrand(_CampaignListDataFetcher_brand, this, _waitForCache).call(this, cacheKey);
  if (this.cache[cacheKey]) return this.cache[cacheKey];
  try {
    _classPrivateFieldGet(_activeFetches, this).push(cacheKey);
    const {
      response
    } = await svs.core.jupiter.callAsync({
      path: "/draw/1/campaign/datepicker?year=".concat(year, "&month=").concat(month, "&product=").concat(product),
      method: 'GET'
    });
    _classPrivateFieldSet(_activeFetches, this, _classPrivateFieldGet(_activeFetches, this).filter(ck => ck !== cacheKey));
    this.cache[cacheKey] = processCampaignListResponse(response);
    return this.cache[cacheKey];
  } catch (err) {
    logger.warn('Could not get campaign data from API', err);
    return {
      response: {}
    };
  }
}
svs.numbergames.campaign._internal.CampaignListDataFetcher = CampaignListDataFetcher;

 })(window);